import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiLoginResponse } from '../interfaces/my-account.interface';
import { apiConfiguration } from '../app.config';
import { OrderHistoryService } from './order-history.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MyAccountService {

  constructor(
    private http: HttpClient,

  ) { }

  preSend(email: string): Observable<ApiLoginResponse> {
    const url = environment.url + "/v1/web/otp/login/pre-send/" + email;
    return this.http.post<ApiLoginResponse>(url, {});
  }

  sendOtp(emailString: string, email: boolean, whatsapp: boolean, sms: boolean): Observable<ApiLoginResponse> {
    const url = environment.url + "/v1/web/otp/login/send/" + emailString;
    return this.http.post<ApiLoginResponse>(url, { activeSms: sms, activeWhatsapp: whatsapp, activeEmail: email });
  }

  verifyOtp(email: string, otp: string): Observable<ApiLoginResponse> {
    const url = environment.url + "/v1/web/otp/login?email=" + email + "&otp=" + otp;
    return this.http.post<ApiLoginResponse>(url, {});
  }

  getOrderCodeOtp(internalOrderNumber: string) {
    const url = environment.url + "/v1/web/otp/internalOrdernumberMax?internalOrdernumber=" + internalOrderNumber;
    return this.http.get<ApiLoginResponse>(url);
  }

  getOrderCodeOtpExternal(internalOrderNumber: string) {
    const url = environment.url + "/v1/web/otp/externalOrdernumberMax?externalOrdernumber=" + internalOrderNumber;
    return this.http.get<ApiLoginResponse>(url);
  }

  sendOtpNotification(otp: string): Observable<ApiLoginResponse> {
    const url = environment.url + "/v1/web/otp/notifications?internalOrdernumber=" + otp;
    return this.http.get<ApiLoginResponse>(url);
  }

  existOrderOtp(internalOrderNumber?: string | null, externalOrderNumber?: string | null) {
    let url = environment.url + "/v1/web/otp/exist-order-numbers-max?";
    if (internalOrderNumber != null) url = url + "internalOrdernumber=" + internalOrderNumber;
    if (externalOrderNumber != null) url = url + "externalOrdernumber=" + externalOrderNumber;
    return this.http.get<ApiLoginResponse>(url);
  }

  setToken(token: string) {
    if (typeof window !== 'undefined' && window.sessionStorage) {
      sessionStorage.setItem("authToken", token)
    }
  }

  getToken() {
    if (typeof window !== 'undefined') {
      const token = sessionStorage.getItem("authToken");
      if (token) {
        return token.replace(/\s+/g, '');
      }
    }
    return null;
  }

  setEmail(email: string) {
    if (typeof window !== 'undefined' && window.sessionStorage) {
      sessionStorage.setItem("userEmail", email)
    }
  }

  getEmail() {
    if (typeof window !== 'undefined' && window.sessionStorage) {
      return sessionStorage.getItem("userEmail")
    }
    return null;
  }

  isAutenticated() {
    return this.getToken() != null && this.getToken() != "" && this.getToken() != undefined;
  }

  logout() {
    if (typeof window !== 'undefined' && window.sessionStorage) {
      sessionStorage.removeItem("authToken");
      sessionStorage.removeItem("userEmail");
      sessionStorage.removeItem("orderHistoryData");
    }
  }


}
